module.exports = __webpack_public_path__ + "img/106.0acdca95.jpg";